import React, { Fragment, useState } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import IconButton from "@material-ui/core/IconButton";

import IconClose from "@material-ui/icons/Close";
import { Job } from "models/job/Job";
import JobLogs from "./logs/Logs.template";
import ChildJobs from "./child-jobs/ChildJobs.template";

export function PreviewJob({
  t,
  job,
  close
}: {
  job: Job;
  close: () => void;
} & WithTranslation) {
  const [applicationState, setApplicationState] = useState(null);
  const [activeTabIndex, setActiveTabIndex] = React.useState(0);

  const tabs = [
    {
      label: t("job.details.logs.title"),
      component: <JobLogs job={job} setApplicationState={setApplicationState} />
    },
    {
      label: t("job.details.children.title"),
      component: (
        <ChildJobs job={job} setApplicationState={setApplicationState} />
      )
    }
  ];

  const handleChange = (_event: React.ChangeEvent<{}>, newValue: number) =>
    setActiveTabIndex(newValue);

  return (
    <Fragment>
      <div className="d-flex justify-content-between modal-header py-2 px-3">
        <div className="d-flex align-items-center">
          <IconButton onClick={close} className="mr-3">
            <IconClose fontSize="small" />
          </IconButton>
          <h5 className="modal-title">
            <span className="badge badge-warning mr-2">
              {t(`application.preview.status.${applicationState}`)}
            </span>
            <span className="mr-2">
              {t(`job.list.column.id`)}: {job.id} |
            </span>
            <span>
              {t(`job.list.column.application`)}:{" "}
              {job.application
                ? `${job.application.name} (${job.application.id})`
                : "---"}
            </span>
          </h5>
        </div>
      </div>
      <div
        style={{
          backgroundColor: "rgb(241, 243, 244)",
          borderBottom: "1px solid rgb(222, 226, 230)"
        }}
      >
        <Tabs
          value={activeTabIndex}
          onChange={handleChange}
          indicatorColor="secondary"
          textColor="secondary"
        >
          {tabs.map(({ label, component, ...tab }, index) => (
            <Tab key={index} label={label} {...tab} />
          ))}
        </Tabs>
      </div>
      {tabs.map(
        (tab, index) =>
          activeTabIndex === index && (
            <Fragment key={index}>{tab.component}</Fragment>
          )
      )}
    </Fragment>
  );
}

export default withTranslation()(PreviewJob);
